module.exports = __webpack_public_path__ + "static/img/ability01.2be72126.webp";